import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  pdf,
  Image,
} from "@react-pdf/renderer";

// Define styles
const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 9, fontFamily: "Helvetica", paddingTop: 6 },
  section: { marginBottom: 10 },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  schoolInfo: { flex: 1, alignItems: "center", marginLeft: -15 },
  title: { fontSize: 16, textAlign: "center", marginBottom: 10 },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    marginTop: 4,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { flexDirection: "row" },
  tableColHeader: {
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#eeeeee",
    padding: 4,
    fontWeight: "bold",
  },
  tableColHeader2: {
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#eeeeee",
    padding: 4,
    fontWeight: "bold",
  },
  tableCol: {
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
  },
  tableCol2: {
    textAlign: "right",
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
  },
  footer: { marginTop: 10, textAlign: "right", fontWeight: "bold" },
  label: { fontWeight: "bold", marginBottom: 0 },
  separator: { borderBottom: "1 solid black", marginVertical: 5 },
  separator2: { borderBottom: "1 solid black", marginVertical: 3 },
});

const AnnexurePDF12 = ({
  modalData,
  modalchallan,
  schoolCode,
  schoolName,
  formattedDateTime,
  totalFees,
  annexureDateTime,
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* <Text style={styles.title}>Annexure</Text>

      <View style={styles.section}>
        <Text>School Code: {schoolCode}</Text>
        <Text>School Name: {schoolName}</Text>
        <Text>Challan No: {modalchallan.challaN_NO}</Text>
        <Text>Challan Date: {modalchallan.challaN_ENTRY_DATE}</Text>
        <Text>Challan Time: {modalchallan.challaN_ENTRY_TIME}</Text>
      </View> */}
      <View style={{ width: 150, alignSelf: "flex-end" }}>
        <Text style={{ fontSize: 8, textAlign: "right" }}>
          <Text style={{ fontWeight: "bold" }}>Generated On:</Text>{" "}
          {annexureDateTime}
        </Text>
      </View>

      <View style={styles.header}>
        <Image
          src="../assets/images/jac-academic-council.png"
          style={{ width: 40, height: 40 }}
        />
        <View style={styles.schoolInfo}>
          <Text style={{ fontSize: 12, fontWeight: "bold" }}>
            Jharkhand Academic Council, Ranchi
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Class XII Annexure -</Text>
            &nbsp;2026 (Annual)
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>School Code: </Text>
            {schoolCode}
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>School Name: </Text>
            {schoolName}
          </Text>
        </View>
      </View>

      <View style={styles.separator} />

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: "-5px",
        }}
      >
        <Text style={styles.section}>
          <Text style={styles.label}>Challan No: </Text>{" "}
          {modalchallan.challaN_NO}
        </Text>
        <Text style={styles.section}>
          <Text style={styles.label}>Challan Generated On: </Text>
          {modalchallan.challaN_ENTRY_DATE} | {modalchallan.challaN_ENTRY_TIME}
        </Text>
      </View>

      <View style={styles.separator2} />

      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <Text style={styles.tableColHeader}>Candidate's Name</Text>
          <Text style={styles.tableColHeader}>Gender</Text>
          <Text style={styles.tableColHeader2}>Attempt</Text>
          <Text style={styles.tableColHeader}>Board</Text>
          <Text style={styles.tableColHeader}>Caste</Text>
          <Text style={styles.tableColHeader}>Category</Text>
          <Text style={styles.tableColHeader}>Registration Fees</Text>
          <Text style={styles.tableColHeader}>Late Fees</Text>
        </View>

        {/* Table Rows */}
        {modalData.map((student, idx) => (
          <View style={styles.tableRow} key={idx}>
            <Text style={styles.tableCol}>{student.candidatE_NAME || ""}</Text>
            <Text style={styles.tableCol}>{student.gender || ""}</Text>
            <Text style={styles.tableCol2}>{student.attempt || ""}</Text>
            <Text style={styles.tableCol}>{student.boarD_NAME || ""}</Text>
            <Text style={styles.tableCol}>{student.castE_NAME || ""}</Text>
            <Text style={styles.tableCol}>
              {student.studenT_EXAM_CATEGORY_DESCRIPTION || ""}
            </Text>
            <Text style={styles.tableCol2}>{student.exaM_FEES || "0"}</Text>
            <Text style={styles.tableCol2}>{student.latE_FEE || "0"}</Text>
          </View>
        ))}

        {/* Total Row */}
        {/* <View style={styles.tableRow}>
          <Text style={[styles.tableCol, { fontWeight: "bold" }]}></Text>
          <Text style={[styles.tableCol, { fontWeight: "bold" }]}></Text>
          <Text style={[styles.tableCol, { fontWeight: "bold" }]}></Text>
          <Text style={[styles.tableCol, { fontWeight: "bold" }]}>
            Total Fees
          </Text>
          <Text style={[styles.tableCol, { fontWeight: "bold" }]}>
            {totalFees.toFixed(2)}
          </Text>
          <Text style={styles.tableCol}></Text>
        </View> */}
      </View>
    </Page>
  </Document>
);

export default AnnexurePDF12;
